import React from "react";
import Paragraph from "./Paragraph";

const Portfolio = () => {
  return (
    <div id="portfolio">
      <div className="container">
        <div className="portfolio-content">
          <Paragraph />
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
